var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M20.624 7.105l-1.818 1.818-3.73-3.73 1.818-1.818a1.014 1.014 0 0 1 1.399 0l2.331 2.331a1.014 1.014 0 0 1 0 1.399zM3.003 17.268L14.005 6.266l3.73 3.73L6.733 20.998h-3.73v-3.73z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }